// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___3zWTx","skeleton-loading":"styles__skeleton-loading___3CcCV","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___3nW71","skeleton-loader-gradient":"styles__skeleton-loader-gradient___2zJu1","table":"styles__table___2LsDm","tableHeader":"styles__tableHeader___3herO","itemValue":"styles__itemValue___1M3H6","itemsClasses":"styles__itemsClasses___28IAU","tableBody":"styles__tableBody___7iyPn","mainSectionSkeleton":"styles__mainSectionSkeleton___1Ejto"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/OrdersTermSkeleton/styles.css
// module id = 2540
// module chunks = 0